// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avJh1SGJ259yb_ {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 104px;
  margin-right: 16px;
  margin-bottom: 16px;
  text-align: center;
}
.avJh1SGJ259yb_:last-of-type {
  margin-right: 0;
}
.avJh1SGJ259yb_ .OizTUEIlzDgtNT {
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
}
.avJh1SGJ259yb_ .WOOhHoqNNk1y5u {
  position: relative;
  width: 104px;
  height: 104px;
}
.avJh1SGJ259yb_ .WOOhHoqNNk1y5u::before {
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity 0.3s;
  opacity: 0;
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
}
.avJh1SGJ259yb_ .Mso6P00nzjSg_P {
  width: 104px;
  height: 104px;
  border-radius: 3px;
}
.avJh1SGJ259yb_ .A2qOFKWdcU_KeW {
  margin-top: 8px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
}
.avJh1SGJ259yb_:hover {
  background-color: transparent;
}
.avJh1SGJ259yb_:hover .WOOhHoqNNk1y5u::before {
  opacity: 1;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tileLinkContainer": `avJh1SGJ259yb_`,
	"tileLink": `OizTUEIlzDgtNT`,
	"tileImageContainer": `WOOhHoqNNk1y5u`,
	"tileImage": `Mso6P00nzjSg_P`,
	"tileTitle": `A2qOFKWdcU_KeW`
};
export default ___CSS_LOADER_EXPORT___;
